import { Button, H2 } from '@/common'
import { useNavigate } from 'react-router-dom'
import { useSession } from '@/shared/hooks/useSession'
import useI18n from '@/shared/hooks/usei18n'

export default function NoDeclarantsPage() {
  const { session } = useSession()
  const navigate = useNavigate()
  const isAdmin = session.role === 'ADMIN'
  const { t } = useI18n()
  return (
    <div className="flex flex-col items-center justify-center h-full">
      {isAdmin && (
        <div>
          <div className="space-y-2 text-center mb-4">
            <H2>{t('common:noDeclarantsScreen.admin.title')}</H2>
            <p>{t('common:noDeclarantsScreen.admin.description')}</p>
          </div>
          <Button className="w-full" onClick={() => navigate('/cbam-reporting/create-declarant')}>
            {t('common:noDeclarantsScreen.admin.action')}
          </Button>
        </div>
      )}
      {!isAdmin && (
        <div className="space-y-2 text-center">
          <H2>{t('common:noDeclarantsScreen.manager.title')}</H2>
          <p className="text-text-secondary">
            {t('common:noDeclarantsScreen.manager.description')}
          </p>
        </div>
      )}
    </div>
  )
}
